import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "../../../../engine/src/EntryPoint";
import PostMessages from "../postmessages/PostMessages";

export default class InitState extends BaseState {

    constructor(stateData) {
        super(stateData);
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('game:gameStarted', this.onGameStarted, this);
    }

    onGameStarted() {
       /* if(RgPostMessageAPI) {
          RgPostMessageAPI.reportGameReady ();
        }*/
        this.complete();
    }

    start() {

        super.start()
      if(window["FEIM"]) {
        //RgPostMessageAPI.init (true);
          //EntryPoint.PostMessages.init()
          EntryPoint.PostMessages = new PostMessages();
          document.getElementById('rg_pause_modal')
          && document.getElementById('rg_pause_modal').remove();
      }
    }
}
